export default __webpack_public_path__ + "static/media/detail_big_4_4.b64fe32d.png";